import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createClient } from '../../services/clientService';
import ClientForm from '../../components/clients/ClientForm';
import './NewClient.css';

const NewClient = () => {
  const navigate = useNavigate();
  
  const handleSave = async (clientData) => {
    try {
      await createClient(clientData);
      navigate('/clients');
    } catch (error) {
      console.error('Error al crear cliente:', error);
      alert('Error al crear el cliente. Por favor, inténtalo de nuevo.');
    }
  };
  
  const handleCancel = () => {
    navigate('/clients');
  };
  
  return (
    <div className="new-client-container">
      <h1 className="page-title">Alta Contacto</h1>
      
      <ClientForm 
        onSave={handleSave}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default NewClient;